import {get, ref, serverTimestamp, set} from "firebase/database";
import {database} from "../utils/firebase";
import {lc_rule_cfg} from "../static/lc_rule_cfg";
import {ADMIN_CONFIG_PATHS} from "../config/adminConfig";

const RULES_CONFIG_PATH = ADMIN_CONFIG_PATHS.rules;

const rulesConfigService = {
  async loadRulesConfig() {
    const snapshot = await get(ref(database, RULES_CONFIG_PATH));
    if (snapshot.exists()) {
      return snapshot.val();
    }
    return {lc_rule_cfg};
  },

  async saveRulesConfig(uid, rulesConfig) {
    const payload = {
      ...rulesConfig,
      updatedAt: serverTimestamp(),
      updatedBy: uid,
    };
    await set(ref(database, RULES_CONFIG_PATH), payload);
    return payload;
  },
};

export default rulesConfigService;
